<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="section-title">{{ $t("documentvarification") }}</div>
      <router-link class="btn-blue" to="add-document-verification">{{
        $t("add")
      }}</router-link>
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown /> -->
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>
    <div>
      <table class="list-view-table">
        <thead>
          <tr>
            <th>
              <img
                v-if="this.columnName != 'vd_document_name'"
                @click="onSortValue('vd_document_name', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('vd_document_name', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('vd_document_name', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("document") }} {{ $t("name") }}
            </th>
            <th class="text-right">
              <span class="pr-3">{{ $tc("status", 2) }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(document, documentIndex) in documentList"
            :key="documentIndex"
          >
            <td>{{ document.vd_document_name }}</td>
            <td>
              <div class="d-flex align-items-center justify-content-end">
                <!-- <label class="ios-switch">
                  <input
                    :checked="document.vd_is_active == 'Y'"
                    disabled
                    type="checkbox"
                    class="ios-checkbox"
                  />
                  <span class="switch-slider"></span>
                </label> -->
                <StatusDot
                  :status="
                    document.vd_is_active === 'Y'
                      ? 'active'
                      : document.vd_is_active === 'N' && 'inactive'
                  "
                />
                <b-dropdown right variant="edit" class="ml-4">
                  <b-dropdown-item v-on:click="onEditDocument(document)">
                    <span class="edit-pen"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>
                  <b-dropdown-item v-on:click="onViewDocument(document)">
                    <span class="icon-eye"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination
        v-if="documentList.length > 0"
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
export default {
  components: {
    StatusDot,
    FilterByStatusDropdown
  },
  data() {
    return {
      vd_document_name: "",
      vd_document_verifies: "",
      vd_id: "",
      vd_name: "",
      documentList: [],
      // institutes: [],
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ],
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: ""
    };
  },
  beforeMount() {
    this.getDocumentList();
    // this.onViewOffer();
    // this.onEditInstitute();
  },
  methods: {
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getDocumentList();
    },
    getDocumentList: function() {
      MasterService.getAllVerificationDocument(
        this.perPage,
        this.currentPage,
        this.columnName,
        this.orderby
      ).then(response => {
        const { data } = response;
        if (data && data.Records.length > 0) {
          this.documentList = data.Records;
          this.rows = data.totalCount;
          if (this.rows <= this.selectedvalue) {
            this.selectedvalue = this.rows;
          }
        }
      });
    },
    onViewDocument: function(document) {
      this.$router.push({
        path: "/master/view-document-verification",
        query: { vd_id: document.vd_id }
      });
    },
    onEditDocument: function(document) {
      this.$router.push({
        path: "/master/edit-document-verification",
        query: { vd_id: document.vd_id }
      });
      // console.log("bank_id :", bank.bank_id);
    },

    onChangePagination: function(event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getDocumentList();
      } else {
        this.currentPage = event;
        this.getDocumentList();
      }
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        // console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        // console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/DocumentVerification/documentVerification.vue